<template>
	<LoginLayout
		:heading="formTitle"
	>
		<template #form>
			<div v-if="linkValid">
				<div
					v-if="passwordReset"
					class="text-center mt-6"
				>
					<v-btn
						block
						large
						class="sign-in-button text-none"
						@click="redirectToLogin"
					>
						Sign In
					</v-btn>
				</div>
				<validation-observer
					v-else
					#default="{ handleSubmit }"
					class="cassie-vertical-sm"
				>
					<PasswordField
						:id="String(Math.random())"
						v-model="password"
						:rules="{ password: true }"
						label="New Password *"
						field-name="New Password"
						@input="clearSubmissionAttempt"
					/>
					<PasswordField
						:id="String(Math.random())"
						v-model="confirmPassword"
						:rules="{ password: true, confirmed: 'New Password' }"
						label="Confirm New Password *"
						@input="clearSubmissionAttempt"
					/>
					<p class="text-left login-info-text">
						Passwords must be at least 12 characters long, contain a number, an uppercase letter and at least 1 special character (e.g. ! @ # $ £ % ⌃)
					</p>
					<Message v-if="apiRespondedWithWeakPassword">
						This password is too weak
					</Message>
					<v-card-actions class="pa-0 mt-4">
						<v-btn
							block
							large
							class="sign-in-button text-none"
							@click="handleSubmit(resetPassword)"
						>
							Submit
						</v-btn>
					</v-card-actions>
				</validation-observer>
			</div>
			<div
				v-else
				class="text-center"
			>
				<div class="login-icon-roundel mb-6">
					<v-icon size="32">
						mdi-link-variant-off
					</v-icon>
				</div>
				<p class="login-info-text mb-6">
					Your link has expired or has already been used. If you still need to set your password, please request a new link.
				</p>
				<v-btn
					block
					large
					class="sign-in-button text-none"
					@click="redirectToForgottenPassword"
				>
					Request New Link
				</v-btn>
			</div>
		</template>
	</LoginLayout>
</template>

<script>
import LoginLayout from '../../../../../shared/layouts/login-layout.vue'
import PasswordField from '../../../../../shared/components/password-field.vue'
import { resetAdminPortalPasswordApi, checkAdminPortalPasswordResetLinkValidity } from '../../../../../shared/utils/api/forgotten-password.js'
import Message from '../../../../../shared/components/message.vue'

export default {
	components: { Message, LoginLayout, PasswordField },
	props: {
		hash: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			password: '',
			confirmPassword: '',
			apiRespondedWithWeakPassword: false,
			passwordReset: false,
			linkValid: null
		}
	},
	computed: {
		formTitle () {
			if (this.linkValid) {
				if (this.passwordReset) return 'Your password has been set'
				else return 'Set Password'
			} else {
				return 'Link Expired'
			}
		}
	},
	created () {
		this.checkResetPasswordLink()
	},
	methods: {
		async checkResetPasswordLink () {
			const { data: { valid } } = await checkAdminPortalPasswordResetLinkValidity(this.hash)
			this.linkValid = valid
		},
		clearSubmissionAttempt () {
			this.apiRespondedWithWeakPassword = false
		},
		redirectToForgottenPassword () {
			this.$router.push('forgotten-password')
		},
		redirectToLogin () {
			this.$router.push('login')
		},
		async resetPassword () {
			const { hash, password } = this
			try {
				await resetAdminPortalPasswordApi({ hash, password })
				this.apiRespondedWithWeakPassword = false
			} catch (_) {
				this.apiRespondedWithWeakPassword = true
			}
			if (!this.apiRespondedWithWeakPassword) {
				this.passwordReset = true
			}
		}
	}
}
</script>
